const STOREFRONT_CLIENT_URL =
  "https://unpkg.com/@shopify/storefront-api-client@0.2.3/dist/umd/storefront-api-client.min.js";
let storefrontClientLoadPromise = null;

function preloadStorefrontClient() {
  if (typeof ShopifyStorefrontAPIClient !== "undefined") {
    return Promise.resolve(ShopifyStorefrontAPIClient);
  }
  if (storefrontClientLoadPromise) return storefrontClientLoadPromise;
  storefrontClientLoadPromise = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = STOREFRONT_CLIENT_URL;
    s.async = true;
    s.onload = () => resolve(ShopifyStorefrontAPIClient);
    document.head.appendChild(s);
  });
  return storefrontClientLoadPromise;
}

class CustomBundleBuilder extends HTMLElement {
  constructor() {
    super();
    this.client = null;
    this.accordions = this.querySelectorAll(".accordion");
    this.vendors = null;
    if (document.querySelector("#cstm-bundle-builder-vendors")) {
      this.vendors = JSON.parse(
        document
          .querySelector("#cstm-bundle-builder-vendors")
          .textContent.trim()
      );
    }
    if (this.classList.contains("cstm-mega-bundle") || this.classList.contains("cstm-recharge-bundle")) {
      preloadStorefrontClient();
    }

    document.addEventListener("Bundle:Builder:StartLoad", () => {
      this.initClient()
        .then((createStorefrontApiClient) => {
          this.client = createStorefrontApiClient.createStorefrontApiClient({
            storeDomain: window.Shopify.shop,
            apiVersion: "2025-04",
            publicAccessToken: "159136723c4a71560f30844a163a1e71",
            customFetchApi: fetch,
          });
          document.dispatchEvent(
            new CustomEvent("Bundle:Builder:Ready", {
              detail: { client: this.client },
            })
          );
        })
        .then(() => {
          // loop through all vendors and check if its empty then hide it
          this.querySelectorAll(".cstm-bundle-builder-content").forEach(
            (content) => {
              if (
                content
                  .querySelector(".bundle__cards-wrapper")
                  .innerHTML.trim() === ""
              ) {
                content.closest(".product__accordion.accordion").style.display =
                  "none";
              }
            }
          );
          this.classList.remove("loading");
        });
    });

    document.addEventListener("bundle:item-change", () => {
      this.querySelectorAll(".cstm-bundle-builder-content").forEach(
        (content) => {
          if (content.querySelector(".quantity__input")) {
            const quantityInputs = content.querySelectorAll(".quantity__input");
            const quantity = Array.from(quantityInputs).reduce((acc, input) => {
              return acc + parseInt(input.value);
            }, 0);
            content
              .closest("details")
              .querySelector("[data-product-count]")
              .setAttribute("data-count", quantity);
            content
              .closest("details")
              .querySelector(
                "[data-product-count] .product-count-number"
              ).textContent = quantity + " ";
          }
        }
      );
    });

    this.accordions.forEach((item) => {
      const summary = item.querySelector("summary");
      const details = item.querySelector("details");

      if (summary && details) {
        summary.addEventListener("click", (e) => {
          e.preventDefault(); // stop native toggle

          const isOpen = details.hasAttribute("open");

          // Close all
          this.accordions.forEach((accordion) => {
            const d = accordion.querySelector("details");
            const s = accordion.querySelector("summary");
            if (d && s) {
              d.removeAttribute("open");
              s.setAttribute("aria-expanded", "false");
            }
          });

          // Open clicked one if it was previously closed
          if (!isOpen) {
            details.setAttribute("open", "");
            summary.setAttribute("aria-expanded", "true");
          }
        });
      }
    });
  }
  /**
   * Initializes the Shopify Storefront API client (uses preloaded script when available).
   *
   * @returns {Promise} A promise that resolves with the ShopifyStorefrontAPIClient object once the library has loaded.
   */
  initClient() {
    return preloadStorefrontClient();
  }

  async queryProductsByVendor(vendor) {
    let query = `
            query getProducts {
            products(first: 250, query: "vendor:${vendor}") {
                    edges {
                        node {
                            handle
                            title
                        }
                    }
                }
            }
        `;
    const { data } = await this.client.request(query);

    return { data };
  }
}

if (!customElements.get("cstmbundle-builder")) {
  customElements.define("cstmbundle-builder", CustomBundleBuilder);
}
